import type { SVGProps } from 'react';

export const Edit = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 19h1.25L16.5 8.775 15.225 7.5 5 17.75V19Zm-.6 1.5a.934.934 0 0 1-.65-.25.934.934 0 0 1-.25-.65v-1.725c0-.25.042-.483.125-.7.1-.233.233-.425.4-.575L16.7 3.925a1.54 1.54 0 0 1 .5-.3 1.374 1.374 0 0 1 1.15 0c.183.067.35.175.5.325l1.225 1.225c.15.15.258.325.325.525.067.183.1.367.1.55 0 .2-.033.392-.1.575a1.37 1.37 0 0 1-.325.5L7.4 19.975c-.15.167-.342.3-.575.4-.217.083-.45.125-.7.125H4.4ZM19 6.25 17.75 5 19 6.25Zm-3.15 1.9-.625-.65L16.5 8.775l-.65-.625Z" />
    </svg>
  );
};
